import { useDispatch, useSelector } from 'react-redux'
import likeImage from '../../assets/like.svg'
import unlikeImage from '../../assets/unlike.svg'
import { updateVideo } from '../../features/video/videoAPI'
import { likesAction, unlikesAction } from '../../features/video/videoSlice'
export default function LikeUnlike() {
  const dispatch = useDispatch()
  const { likes, unlikes, id } = useSelector((state) => state.video.video)
  const handleLikes = (id) => {
    dispatch(likesAction(1))
    updateVideo(id, { likes: likes + 1 })
  }
  const handleUnlikes = (id) => {
    dispatch(unlikesAction(1))
    updateVideo(id, { unlikes: unlikes + 1 })
  }
  return (
    <div className="flex gap-10 w-48">
      <div className="flex gap-1 cursor-pointer" onClick={() => handleLikes(id)}>
        <div className="shrink-0">
          <img className="w-5 block" src={likeImage} alt="Like" />
        </div>
        <div className="text-sm leading-[1.7142857] text-slate-600">{likes}</div>
      </div>
      <div className="flex gap-1 cursor-pointer" onClick={() => handleUnlikes(id)}>
        <div className="shrink-0">
          <img className="w-5 block" src={unlikeImage} alt="Unlike" />
        </div>
        <div className="text-sm leading-[1.7142857] text-slate-600">{unlikes}</div>
      </div>
    </div>
  )
}
